// extracted by mini-css-extract-plugin
module.exports = {"icon":"EmptyList_icon__EqGXU","title":"EmptyList_title__2jVuF"};